import React from "react";

import AgendaKatomi from "./Katomi";

const Agenda: React.FC = (props) => {
  return <AgendaKatomi {...props} />;
};

export default Agenda;
